import { render, staticRenderFns } from "./ConfigUpdate.vue?vue&type=template&id=c02c3f46"
import script from "./ConfigUpdate.vue?vue&type=script&lang=js"
export * from "./ConfigUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports